import { Decorative } from "@faire/design-tokens";
import { FilterSideBarLoadingSkeleton } from "@faire/retailer-visitor-shared/components/Filters/FilterSideBarLoadingSkeleton";
import { GhostBlock } from "@faire/retailer-visitor-shared/components/GhostLoading/GhostBlock";
import { FilmstripBrandListSkeleton } from "@faire/retailer-visitor-shared/views/suppliers/SuppliersPageLoadingSkeleton/FilmstripBrandListSkeleton";
import { SuppliersPageHeaderLoadingSkeleton } from "@faire/retailer-visitor-shared/views/suppliers/SuppliersPageLoadingSkeleton/SuppliersPageHeaderLoadingSkeleton";
import { Column, Flex } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { ResponsiveContentV2 } from "@faire/web--source/ui/ResponsiveContentV2";
import React from "react";
import styled from "styled-components";

interface IProps {
  hideHeader?: boolean;
}

export const SuppliersPageLoadingSkeleton: React.FC<IProps> = ({
  hideHeader = false,
}) => {
  return (
    <div
      data-test-id="suppliers-page-loading-skeleton"
      style={{
        overflow: "hidden",
      }}
    >
      {!hideHeader ? (
        <>
          <HeaderBackground>
            <HeaderColumn>
              <SuppliersPageHeaderLoadingSkeleton />
            </HeaderColumn>
          </HeaderBackground>
          <Spacer height="9x" />
        </>
      ) : null}

      <MainContentColumn>
        <ResponsiveContentV2
          tabletAndAbove={<GhostBlock $width="400px" $height="38px" />}
          mobile={<GhostBlock $width="300px" $height="38px" />}
        />
        <Spacer height="3x" />
        <Flex
          gap="2x"
          direction={{ mobileAndAbove: "column", desktopAndAbove: "row" }}
        >
          <ResponsiveContentV2
            tabletAndBelow={
              <GhostBlock $height="40px" $borderRadius="20px" $width="120px" />
            }
            desktopAndAbove={
              <FilterSideBarLoadingSkeleton hideSideNav filterCount={6} />
            }
          />
          <FilmstripBrandListSkeleton />
        </Flex>
      </MainContentColumn>
    </div>
  );
};

const HeaderBackground = styled.div`
  background-color: ${Decorative.tint.neutral};
`;

const HeaderColumn = styled(Column)`
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;

  ${responsiveMediaQueries.mobile} {
    padding: 32px 16px 40px 16px;
  }
  ${responsiveMediaQueries.tabletAndAbove} {
    padding: 32px 40px 40px 40px;
  }
  ${responsiveMediaQueries.desktopAndAbove} {
    padding: 32px 80px 40px 80px;
  }
`;

const MainContentColumn = styled(Column)`
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  ${responsiveMediaQueries.mobile} {
    padding: 0px 16px 40px 16px;
  }
  ${responsiveMediaQueries.tabletAndAbove} {
    padding: 0px 40px 40px 40px;
  }
  ${responsiveMediaQueries.desktopAndAbove} {
    padding: 0px 80px 40px 80px;
  }
`;
